import React, { useEffect, useState } from "react";
import { Spinner } from "../../StyledComponent";
import { getEtapasSafi } from "../../../services/meuImovel";
import Fade from "@material-ui/core/Fade";
import { ReactComponent as RegistroContrato } from "../../../assets/novosicones/MeuImovel/safi/SAFI-RegistroDoContrato.svg";
import { ReactComponent as RegistroEscritura } from "../../../assets/novosicones/MeuImovel/safi/SAFI-ContratoRegistrado.svg";
import "./styles.scss";

const EtapasDoRegistro = ({ idOportunidade, corEmpreendimento }) => {
  const [loading, setLoading] = useState(false);
  const [etapa1, setEtapa1] = useState([]);
  const [etapa2, setEtapa2] = useState([]);
  const [showEtapa1, setShowEtapa1] = useState(false);
  const [showEtapa2, setShowEtapa2] = useState(false);
  const [etapaAtiva, setEtapaAtiva] = useState(false);
  const [etapaAtiva2, setEtapaAtiva2] = useState(false);

  var classeSeparadorEtapas = "";

  useEffect(() => {
    setShowEtapa1(false);
    setShowEtapa2(false);
    loadEtapas();
  }, [idOportunidade]);

  async function loadEtapas() {
    setLoading(true);
    let resultGetEtapas = await getEtapasSafi(idOportunidade);

    if (resultGetEtapas == false) {
      setEtapa1([]);
      setLoading(false);
    } else {
      setEtapa1(resultGetEtapas[0]);
      setEtapaAtual(resultGetEtapas[1]);
      resultGetEtapas.shift();
      setEtapa2(resultGetEtapas);
      setLoading(false);
    }
  }

  function setEtapaAtual(etapa) {
    if (etapa.Concluida) {
      setShowEtapa2(true);
      setEtapaAtiva(true);
      setEtapaAtiva2(true);
    } else {
      setEtapaAtiva(true);
      setShowEtapa1(true);
      setEtapaAtiva2(false);
    }
  }

  if (loading) return <Spinner />;

  if (corEmpreendimento == "#003da5")
    classeSeparadorEtapas = "etapasDoRegistro__etapas--imovelDirecional";

  return (
    <>
      {etapa1.length == 0 || etapa2.length == 0 ? (
        <p style={{ textAlign: "center" }}>
          Não foi possível encontrar etapas de registro em seu imóvel/vaga, para
          mais informações entre em contato com o
          <a
            href="https://api.whatsapp.com/send?phone=553140200400&text=%20Ol%c3%a1%21%20Gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20os%20apartamentos%20da%20Direcional%20:)&source=&data="
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#003da5",
              textDecoration: "none",
            }}
          >
            <span> atendimento ao cliente.</span>
          </a>
        </p>
      ) : (
        <Fade in>
          <div className="etapasDoRegistro centralized-column">
            <div
              className={`etapasDoRegistro__etapas centralized-space-between ${classeSeparadorEtapas} ${
                !etapaAtiva2 ? "etapasDoRegistro__etapas--etapa2inativa" : ""
              }`}
            >
              <div
                onClick={() => {
                  setShowEtapa1(true);
                  setShowEtapa2(false);
                }}
                className="centralized-column etapasDoRegistro__etapas__etapa"
              >
                <span
                  className="etapasDoRegistro__etapas__etapa__iconeEtapa"
                  style={
                    showEtapa1
                      ? { border: `2px solid ${corEmpreendimento}` }
                      : { border: "2px solid transparent" }
                  }
                >
                  <span
                    style={
                      etapaAtiva
                        ? { backgroundColor: corEmpreendimento }
                        : { backgroundColor: "#D1D1D1" }
                    }
                  >
                    <RegistroContrato />
                  </span>
                </span>
                <span
                  className="etapasDoRegistro__etapas__etapa__nomeEtapa"
                  style={
                    etapaAtiva
                      ? { color: corEmpreendimento }
                      : { color: "#D1D1D1" }
                  }
                >
                  {etapa1.Etapa.substring(0, 1)
                    .toUpperCase()
                    .concat(etapa1.Etapa.substring(1))}
                </span>
              </div>

              <div
                onClick={() => {
                  setShowEtapa1(false);
                  setShowEtapa2(true);
                }}
                className="centralized-column etapasDoRegistro__etapas__etapa"
              >
                <span
                  className="etapasDoRegistro__etapas__etapa__iconeEtapa"
                  style={
                    showEtapa2
                      ? etapaAtiva2
                        ? { border: `2px solid ${corEmpreendimento}` }
                        : { border: `2px solid #d1d1d1` }
                      : { border: "2px solid transparent" }
                  }
                >
                  <span
                    style={
                      etapaAtiva2
                        ? { backgroundColor: corEmpreendimento }
                        : { backgroundColor: "#D1D1D1" }
                    }
                  >
                    <RegistroEscritura />
                  </span>
                </span>
                <span
                  className="etapasDoRegistro__etapas__etapa__nomeEtapa"
                  style={
                    etapaAtiva2
                      ? { color: corEmpreendimento }
                      : { color: "#D1D1D1" }
                  }
                >
                  {etapa2[0].Etapa.substring(0, 1)
                    .toUpperCase()
                    .concat(etapa2[0].Etapa.substring(1))}
                </span>
              </div>
            </div>

            <div className="etapasDoRegistro__status centralized">
              {showEtapa1 && (
                <Fade in>
                  <ul className="centralized">
                    <span
                      style={
                        etapaAtiva
                          ? { backgroundColor: corEmpreendimento }
                          : { backgroundColor: "#d1d1d1" }
                      }
                    >
                      <RegistroContrato />
                    </span>
                    <p
                      style={
                        etapaAtiva
                          ? { color: corEmpreendimento }
                          : { color: "#d1d1d1" }
                      }
                    >
                      {etapa1.Status}
                    </p>
                  </ul>
                </Fade>
              )}
              {showEtapa2 && (
                <Fade in>
                  <ul className="centralized-column">
                    {etapa2.map((etapa) => (
                      <li key={etapa.Ordenacao} className="centralized">
                        <span
                          style={
                            etapa.Concluida
                              ? { backgroundColor: corEmpreendimento }
                              : { backgroundColor: "#4D4D4D" }
                          }
                        >
                          <RegistroEscritura />
                        </span>
                        <p
                          style={
                            etapa.Concluida
                              ? { color: corEmpreendimento }
                              : { color: "#4D4D4D" }
                          }
                        >
                          {etapa.Status}
                        </p>
                      </li>
                    ))}
                  </ul>
                </Fade>
              )}
            </div>
          </div>
        </Fade>
      )}
    </>
  );
};

export default EtapasDoRegistro;
